/**
 * @internal
 */
export var convertIncludeTypeToNumber = function (includeType) {
    switch (includeType) {
        case "discontinued" /* Discontinued */:
            return 1 /* Discontinued */;
        case "supported" /* Supported */:
            return 2 /* Supported */;
        case "available" /* Available */:
            return 3 /* Available */;
    }
};
